import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getGameImage, getNormalizedGameName } from '../utils/gameImages';
import { createChallengePath } from '../utils/gameSlug';
import './GameCard.css';

export default function GameCard({ game, onClick }) {
  const navigate = useNavigate();
  const [imageError, setImageError] = useState(false);
  const [imageLoading, setImageLoading] = useState(true);

  const getGameInitials = (name) => {
    return name
      .split(' ')
      .map(word => word[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  const getGameColor = (gameId) => {
    const colors = [
      '#e50914', // Red
      '#0071eb', // Blue
      '#00d4ff', // Cyan
      '#ff6b00', // Orange
      '#6c5ce7', // Purple
      '#00b894', // Green
      '#fdcb6e', // Yellow
      '#e17055', // Coral
    ];
    return colors[(gameId - 1) % colors.length];
  };

  const normalizedName = getNormalizedGameName(game.name);
  const imageUrl = getGameImage(game.name);

  const handleImageLoad = () => {
    setImageLoading(false);
    setImageError(false);
  };

  const handleImageError = () => {
    setImageError(true);
    setImageLoading(false);
  };

  const handleClick = () => {
    if (onClick) {
      onClick(game);
    } else {
      navigate(createChallengePath(game));
    }
  };

  return (
    <div className="game-card" onClick={handleClick}>
      <div 
        className="game-card-image" 
        style={{ backgroundColor: imageError ? getGameColor(game.gameId) : '#1a1a1a' }}
      >
        {!imageError ? (
          <>
            {imageLoading && (
              <div className="game-card-loading">
                <div className="game-card-spinner"></div>
              </div>
            )}
            <img
              src={imageUrl}
              alt={game.name}
              className={`game-card-img ${imageLoading ? 'loading' : ''}`}
              onLoad={handleImageLoad}
              onError={handleImageError}
              loading="lazy"
            />
          </>
        ) : (
          <div className="game-card-initials">
            {getGameInitials(game.name)}
          </div>
        )}
      </div>
      <div className="game-card-info">
        <h3 className="game-card-title">{game.name}</h3>
        {game.description && (
          <p className="game-card-description">{game.description}</p>
        )}
        {game.gameId === 1 && (
          <p className="game-card-automation-hint" role="note">
            Auto-payout uses <strong>FACEIT</strong> (third-party). Steam matchmaking: confirm winner together.
          </p>
        )}
        {game.gameId === 4 && (
          <p className="game-card-automation-hint" role="note">
            Auto-payout uses <strong>Ballchasing</strong> (third-party replay site; PC upload).
          </p>
        )}
      </div>
    </div>
  );
}
